function Error() {
  return (
    <div>
      <h1>500 Error</h1>
    </div>
  );
}

export default Error;
